import { useEffect, useState } from "react";
import {
  Box, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody,
  TextField, Button, Grid, Dialog, DialogTitle, DialogContent,
  DialogActions, Alert
} from "@mui/material";

import { sellBikeService } from "../service/SellBikeService";

const SellBike = () => {

  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [filters, setFilters] = useState({
    model: "",
    colour: "",
    location: "",
    search: "",
  });

  const [open, setOpen] = useState(false);
  const [selectedBike, setSelectedBike] = useState(null);

  const [form, setForm] = useState({
    customerName: "",
    mobile: "",
    address: "",
    salePrice: "",

    cashAmount: "",
    financeCompany: "",
    financeAmount: "",

    exchange: {
      vehicleModel: "",
      engineNumber: "",
      chasisNumber: "",
      exchangeAmount: ""
    }
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // 🚀 Fetch bikes
  const fetchStock = async () => {
    const res = await sellBikeService.getAvailableStock({
      ...filters,
      status: "IN_STOCK"
    });

    let bikes = [];
    res.data?.forEach((loc) => bikes.push(...loc.bikes));

    setData(bikes);
    setFiltered(bikes);
  };

  useEffect(() => {
    fetchStock();
  }, []);

  // 🔍 search
  const handleSearch = (value) => {
    setFilters({ ...filters, search: value });

    const filteredData = data.filter(
      (b) =>
        b.engine.toLowerCase().includes(value.toLowerCase()) ||
        b.chasis.toLowerCase().includes(value.toLowerCase())
    );

    setFiltered(filteredData);
  };

  // 🔥 open popup
  const openModal = (bike) => {
    setSelectedBike(bike);
    setOpen(true);
  };

  // 🔄 handle change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleExchangeChange = (e) => {
    setForm({
      ...form,
      exchange: {
        ...form.exchange,
        [e.target.name]: e.target.value
      }
    });
  };

  // 💰 SELL
  const handleSell = async () => {
    try {
      setError("");

      await sellBikeService.sellBike({
        bikeId: selectedBike._id,
        saleBikeEngineNumber: selectedBike.engine,
        saleBikeChasisNumber: selectedBike.chasis,
        ...form
      });

      setSuccess("Bike sold successfully ✅");
      setOpen(false);
      fetchStock();

    } catch (err) {
      setError(err.response?.data?.message || "Sell failed");
    }
  };

  return (
    <Box>
      <Typography variant="h4">Sell Bike</Typography>

      {/* 🔍 FILTER */}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              label="Search Engine/Chasis"
              fullWidth
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Button variant="contained" fullWidth onClick={fetchStock}>
              Apply Filter
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* 📊 TABLE */}
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Model</TableCell>
              <TableCell>Engine</TableCell>
              <TableCell>Chasis</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filtered.map((bike) => (
              <TableRow key={bike._id}>
                <TableCell>{bike.model}</TableCell>
                <TableCell>{bike.engine}</TableCell>
                <TableCell>{bike.chasis}</TableCell>
                <TableCell>{bike.location}</TableCell>

                <TableCell>
                  <Button
                    variant="contained"
                    onClick={() => openModal(bike)}
                  >
                    Sell
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      {/* 🔥 SELL MODAL */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>Sell Bike</DialogTitle>

        <DialogContent>

          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}

          <TextField label="Customer Name" name="customerName" fullWidth onChange={handleChange} sx={{ mt: 2 }} />
          <TextField label="Mobile" name="mobile" fullWidth onChange={handleChange} sx={{ mt: 2 }} />
          <TextField label="Address" name="address" fullWidth onChange={handleChange} sx={{ mt: 2 }} />

          <TextField label="Sale Price" name="salePrice" fullWidth onChange={handleChange} sx={{ mt: 2 }} />

          <Typography mt={2}>Payment</Typography>
          <TextField label="Cash Amount" name="cashAmount" fullWidth onChange={handleChange} sx={{ mt: 1 }} />
          <TextField label="Finance Company" name="financeCompany" fullWidth onChange={handleChange} sx={{ mt: 1 }} />
          <TextField label="Finance Amount" name="financeAmount" fullWidth onChange={handleChange} sx={{ mt: 1 }} />

          <Typography mt={2}>Exchange</Typography>
          <TextField label="Vehicle Model" name="vehicleModel" fullWidth onChange={handleExchangeChange} sx={{ mt: 1 }} />
          <TextField label="Engine Number" name="engineNumber" fullWidth onChange={handleExchangeChange} sx={{ mt: 1 }} />
          <TextField label="Chasis Number" name="chasisNumber" fullWidth onChange={handleExchangeChange} sx={{ mt: 1 }} />
          <TextField label="Exchange Amount" name="exchangeAmount" fullWidth onChange={handleExchangeChange} sx={{ mt: 1 }} />

        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSell}>
            Confirm Sale
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default SellBike;